import { render } from "./AnalisiDelTalento.vue?vue&type=template&id=36e464d3&scoped=true"
import script from "./AnalisiDelTalento.vue?vue&type=script&lang=js"
export * from "./AnalisiDelTalento.vue?vue&type=script&lang=js"

import "./AnalisiDelTalento.vue?vue&type=style&index=0&id=36e464d3&lang=scss&scoped=true"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e464d3"]])

export default __exports__